/* eslint-disable */
import React, { useEffect, useState } from "react";
import Header from "./Header";
import Container from "../UI/Container";

import InventoryStatus from "./InventoryStatus";
import ShippingHistory from "./ShippingHistory";
import MaterialRelease from "./MaterialRelease";
import Invoices from "./Invoices";
import User from "./user";
// import "react-tabs/style/react-tabs.css";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

const MainPage = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [details, setDetails] = useState(null);
  let detail
  useEffect(() => {
    
      try {
    
        detail = localStorage.getItem("detail");
       let data =JSON.parse(detail)
       if(!data){
        alert("Unauthorise")
        const usertype =localStorage.getItem("type")
      
        window.location.href = "/login?type="+usertype;
        localStorage.clear();
       }
        setDetails(data)
      } catch (error) {
        alert("Unauthorise")
        const usertype =localStorage.getItem("type")
     
        window.location.href = "/login?type="+usertype;
        localStorage.clear();
      
      }
    
   
  }, []);
// 0 false


  return (
    <>
      <Container
        className="ixMainLayout"
        sx={{ display: "flex", flexDirection: "column", overFlow: "auto" }}>
        {/* header with tabs */}
        <Header />
        
        <Container
          className="ixBrowseLayout"
          sx={{
            overFlow: "auto",
            display: "flex",
            flex: 1,
            flexDirection: "column",
          }}
        >
        
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <TabList>
          
            {details?.hideInvtSts ===0?  <Tab>Inventory Status </Tab>:null} 
           {details?.hideShpgHst ===0?  <Tab>Shipping History </Tab>:null} 
           {details?.hideMatRls===0?   <Tab>Material Release </Tab>:null} 
           {details?.hideInv===0?  <Tab>Invoices </Tab>:null} 
           {details?.hideUsr===0?   <Tab>User </Tab>:null} 
            </TabList>

            {details?.hideInvtSts ===0?    <TabPanel key={"1"}>
              <InventoryStatus />
            </TabPanel>:null} 
            {details?.hideShpgHst ===0?  <TabPanel key={"2"}>
              <ShippingHistory />
            </TabPanel>:null} 
           {details?.hideMatRls ===0?   <TabPanel key={"3"}>
              <MaterialRelease />
            </TabPanel>:null} 
            {details?.hideInv ===0?  <TabPanel key={"4"}>
              <Invoices />
            </TabPanel>:null} 
            {details?.hideUsr ===0?  <TabPanel key={"5"}>
              <User />
            </TabPanel>:null} 
          </Tabs>
        </Container>
      </Container>
    </>
  );
};

export default MainPage;
